import React from "react";
import { connect } from "react-redux";
import Loader from "./Loader";

const Overlay = (props) => {
  if (!props.floatingMenu && !props.exportLoading) {
    return null;
  }
  return (
    <div
      style={{
        backgroundColor: "rgba(0,0,0,0.5)",

        right: 0,
        left: 0,
        bottom: 0,
        zIndex: props.exportLoading ? 11 : 9,
        position: "fixed",
        top: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {props.exportLoading && (
        <div className="d-flex flex-column">
          <h3 className="text-white">Stiamo generando il tuo documento</h3>
          <Loader background={"transparent"} width={"unset"} height={"unset"} />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    floatingMenu: state.floatingMenu.isOpen,
    exportLoading: state.cartReducer.exportLoading,
  };
};

export default connect(mapStateToProps, null)(Overlay);
